<style lang="scss" scoped>
.referral-respond {
	&__actions {
		margin-top: 20px;
		span {
			margin-left: 20px;
		}
	}
}
</style>

<template lang="pug">
    .referral-respond
        el-card.panel
            el-form(:rules="rules", ref="form", :model="response", label-position='top')
                el-form-item(prop="message", label="Respond to referral")
                    el-input(type='textarea' v-model="response.message", rows='3')
                .referral-respond__actions
                    el-button(type="danger" @click='revokeAccessRequest', :loading="loading") Revoke Access Request
                    el-button(type="primary" @click='sendResponse', :loading="loading") Send response
                    span Submitting this response will assign this integration back to Wonde.
</template>

<script>
import ConfirmDeletion from "@/components/modals/ConfirmDeletion";
import gql from "graphql-tag";

export default {
	name: "ReferralRespond",
	props: {
		referral: Object
	},
	data() {
		return {
			rules: {
				message: [{ required: true, message: "Please provide a message", trigger: "blur" }]
			},
			loading: false,
			response: {
				message: null
			}
		};
	},
	methods: {
		async revokeAccessRequest() {
			this.$vuedals.open({
				component: ConfirmDeletion,
				title: "Are you sure you want to revoke this access request?",
				props: {
					value: "confirm"
				},
				onClose: async confirm => {
					if (confirm) {
						try {
							await this.$apollo.mutate({
								mutation: gql`
									mutation DeleteReferralCase($case_id: ID!) {
										DeleteReferralCase(case_id: $case_id)
									}
								`,
								variables: {
									case_id: this.$route.params.referral
								}
							});
							this.$router.push({ name: "referrals" });
							this.$message.success("The access request has been revoked");
						} catch (error) {
							this.$message.error("Error revoking access request. Please try again later");
						}
					}
				}
			});
		},
		async sendResponse() {
			this.loading = true;

			let valid = [];

			try {
				valid = await this.$refs.form.validate();

				if (valid) {
					await this.$apollo.mutate({
						mutation: gql`
							mutation CreateReferralEvent($input: CreateReferralEventInput!) {
								CreateReferralEvent(input: $input) {
									id
									type
									payload
									created_at
									blocker
									hard_blocker
								}
							}
						`,
						variables: {
							input: {
								cases_id: this.$route.params.referral ? this.$route.params.referral : this.referral.id,
								message: this.response.message
							}
						},
						update: (store, { data: { CreateReferralEvent } }) => {
							const query = gql`
								query ReferralEvents($caseIds: String) {
									ReferralEvents(caseIds: $caseIds) {
										id
										type
										payload
										created_at
										blocker
										hard_blocker
									}
								}
							`;
							const data = store.readQuery({ query: query, variables: { caseIds: this.referral.id } });
							data.ReferralEvents.unshift(CreateReferralEvent);

							store.writeQuery({ query: query, data });
						}
					});

					this.response.message = null;

					this.$message.success("Saved successfully");
				} else {
					this.$message.error("Failed to respond, please contact support if problem persists.");
				}
			} catch (error) {
				this.$message.error("Failed to respond, please contact support if problem persists.");
			}

			this.loading = false;
		}
	}
};
</script>
